import React from 'react';
import './CalculatingLoader.css';

interface CalculatingLoaderProps {
    // light: white bars for blue buttons; primary: brand-blue bars for light surfaces
    variant?: 'light' | 'primary';
    // overall height in px (default 18); bar width and gaps scale with it
    size?: number;
    // optional status text centred beneath the bars, e.g. "Generating report..."
    label?: string;
    className?: string;
}

// Three staggered bars for the financial reports' "calculating" state. The bars are decorative; pass
// label to show (and announce) a short status beneath them.
export const CalculatingLoader: React.FC<CalculatingLoaderProps> = ({ variant = 'primary', size, label, className }) => {
    const extraClass = className ? ` ${className}` : '';
    const bars = (
        <span
            className={`calculating-loader calculating-loader--${variant}${label ? '' : extraClass}`}
            style={size ? ({ '--calculating-loader-size': `${size}px` } as React.CSSProperties) : undefined}
            aria-hidden="true"
        >
            <span className="calculating-loader__bar"></span>
            <span className="calculating-loader__bar"></span>
            <span className="calculating-loader__bar"></span>
        </span>
    );
    if (!label) return bars;
    return (
        <span className={`calculating-loader-status${extraClass}`} role="status">
            {bars}
            <span className="calculating-loader-status__label">{label}</span>
        </span>
    );
};

export default CalculatingLoader;
